import React from 'react';
import { RefundManagementComponent } from '../../index';

const Desktop = (props) => {
    return <RefundManagementComponent {...props} />;
};

export default Desktop;
